import X from './X';

export default X;